import {Time} from 'yougile-util'
import {DataObjectId} from './data-object'
import {User} from './user'

export type UserStatus = 'online' | 'offline'

export const youGileUserId =
  '0000bdc7-0363-4d30-b5d3-5e0fc72f811f' as DataObjectId
export const yougileUser: User = (() =>
  new User('' as DataObjectId, youGileUserId, ''))()

export const isUserAvatarOk = (
  avatar: string | undefined
): avatar is string => {
  return avatar === '' || (avatar?.startsWith('/user-data/') ?? false)
}

/**
 * Contains general information available to other YouGile users:
 * basic account info and status.
 */
export class UserAccount {
  public id: DataObjectId
  public realName: string
  public avatar: string
  public typing?: [DataObjectId, number] // [Hub.id, timestamp]

  public status: UserStatus
  public lastActivity: number
  public lastMobileActivity?: number
  public dndUntil: number

  constructor(id: DataObjectId, realName: string, avatar?: string) {
    this.id = id
    this.realName = realName
    this.avatar = isUserAvatarOk(avatar) ? avatar : ''
    this.typing = undefined

    this.status = 'offline'
    this.lastActivity = 0
    this.lastMobileActivity = 0
    this.dndUntil = 0
  }

  public static isInDnd(account: UserAccount): boolean {
    return account.dndUntil > Time.now()
  }
}

export const emptyAccount = (userId: DataObjectId) =>
  new UserAccount(userId, '', '')
